import Box from '@mui/material/Box';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { ArrowDownward, ArrowUpward, Delete, Edit } from '@mui/icons-material';

export default function TableActionBasic({
    columns,
    values,
    handleDelete,
    handleEdit,
    onMoveUp,
    onMoveDown,
    editingIndex = null,
    t,
}) {
    const hasReorder = Boolean(onMoveUp && onMoveDown);
    const actionWidth = (handleEdit ? 40 : 0) + (hasReorder ? 70 : 0) + 40;

    return (
        <TableContainer sx={{ mt: 2, mb: 4 }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {hasReorder && <TableCell align="center" style={{ width: 70 }}>Orden</TableCell>}
                        <TableCell align="center" style={{ width: actionWidth }} />
                        {columns.map((col, index) => <TableCell key={`tc-${index}`}>{col.label}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {values.map((item, idx) => (
                        <TableRow
                            key={item.id ?? idx}
                            sx={{
                                height: 40,
                                backgroundColor: editingIndex === idx ? 'action.hover' : 'inherit',
                            }}
                        >
                            {hasReorder && (
                                <TableCell align="center">
                                    <Tooltip title="Subir">
                                        <span>
                                            <IconButton
                                                size="small"
                                                disabled={idx === 0}
                                                onClick={() => onMoveUp(idx)}
                                            >
                                                <ArrowUpward fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Bajar">
                                        <span>
                                            <IconButton
                                                size="small"
                                                disabled={idx === values.length - 1}
                                                onClick={() => onMoveDown(idx)}
                                            >
                                                <ArrowDownward fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </TableCell>
                            )}
                            <TableCell align="center">
                                {handleEdit && (
                                    <Tooltip title={t('edit')}>
                                        <IconButton
                                            size="small"
                                            color={editingIndex === idx ? 'secondary' : 'primary'}
                                            onClick={() => handleEdit(item.id, idx)}
                                        >
                                            <Edit fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title={t('delete')}>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() => handleDelete(item.id, idx)}
                                    >
                                        <Delete fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            {columns.map((col, index) => (
                                <TableCell key={`td-${index}`}>
                                    <Typography variant="body2">
                                        {typeof item[col.id] === 'boolean' ? (item[col.id] ? 'Sí' : 'No') : item[col.id]}
                                    </Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
